export default "__VITE_ASSET__2f0588be__"